import { render, staticRenderFns } from "./support-nav.vue?vue&type=template&id=453ec6d5&scoped=true&"
import script from "./support-nav.vue?vue&type=script&lang=js&"
export * from "./support-nav.vue?vue&type=script&lang=js&"
import style0 from "./support-nav.vue?vue&type=style&index=0&id=453ec6d5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ec6d5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default,LinkTo: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/LinkTo.vue').default})
